/*
 * language Actions
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 11-Jan-2024
 */

import {
  // createRequestTypes,
  createAction
  // MakeRequest,
} from './index'

export const actionTypes = {
  DO_SET_LANGUAGE_PROVIDER: '@@language.js/set_language_provider'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action
/** @action
  * * Insert a description
  * @name SetLanguageProvider
  * @return {object} - The payload object
  */
export const doSetLanguageProvider = payload => createAction(actionTypes.DO_SET_LANGUAGE_PROVIDER, { payload })
